export const logError = (error: unknown, context?: string) => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  console.error(`[${context || 'App'}]`, errorMessage);
  
  // Add detailed logging for errors
  if (error instanceof Error) {
    console.error('Error details:', {
      name: error.name,
      message: error.message,
      stack: error.stack,
      context,
      timestamp: new Date().toISOString(),
      url: window.location.href
    });
  }
  
  try {
    // Attempt to persist error to sessionStorage for debugging
    const errorLog = JSON.parse(sessionStorage.getItem('errorLog') || '[]');
    errorLog.push({
      timestamp: new Date().toISOString(),
      message: errorMessage,
      context,
      url: window.location.href
    });
    // Keep only the latest 10 errors
    sessionStorage.setItem('errorLog', JSON.stringify(errorLog.slice(-10)));
  } catch (e) {
    // Silently fail if storage operations fail
  }
  
  return errorMessage;
};

export const handleGlobalError = (event: ErrorEvent) => {
  logError(event.error, 'Global');
  
  // Log additional context about the error
  console.error('Error event details:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    timestamp: new Date().toISOString(),
  });
  
  // Prevent the error from being swallowed
  event.preventDefault();
};

// Add utility to help recover from errors
export const attemptErrorRecovery = (callback: () => void, fallback?: () => void) => {
  try {
    callback();
  } catch (error) {
    logError(error, 'ErrorRecovery');
    console.error('Recovery attempt failed:', error);
    
    if (fallback) {
      try {
        fallback();
      } catch (fallbackError) {
        logError(fallbackError, 'FallbackFailed');
      }
    }
  }
};
